import { Dialog, DialogContent, Typography } from '@material-ui/core'
import PhysicianDetailsForm from './PhysicianDetailsForm'
import useStyles from './styles'

interface PhysicianDetailsModalProps {
  open: boolean
  nextAction: () => void
}

const PhysicianDetailsModal = ({
  open,
  nextAction,
}: PhysicianDetailsModalProps) => {
  const classes = useStyles()

  return (
    <Dialog open={open} title="Edit Reservation">
      <DialogContent className={classes.detailsDialog}>
        <Typography color="textPrimary" variant="h6">
          You're almost there!
        </Typography>
        <PhysicianDetailsForm nextAction={nextAction} />
      </DialogContent>
    </Dialog>
  )
}

export default PhysicianDetailsModal
